














































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
const dateFormat = require('bmh/date-format');
import storage from 'baimahu/storage';
const { VUE_APP_FCAPI: FCAPI } = process.env;

@Component
export default class Authorize extends Vue {
  isLoading: boolean = false;
  isAuthorize: string = ''; // isAuthorize = 1 --> 默认状态，立即授权， isAuthorize = 2 --> 授权成功，展示小程序信息， isAuthorize = 3 --> 授权失败，重新授权
  authCode: any = '';
  wxAppInfo: any = {};
  api: string = `${FCAPI}/shang/weixin/open/authorizer`;
  package_type: number = 1;

  get merchant_id() {
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    return merchant_id;
  }

  async authorize() {
    const res: AxiosResponse = await this.$axios.get(`${this.api}/new`);
    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      this.isLoading = false;
      return;
    }
    window.location.href = remote.data;

    this.isLoading = false;
  }

  async query() {
    this.isLoading = true;

    const res: AxiosResponse = await this.$axios.get(
      `${this.api}/${this.merchant_id}`
    );

    const remote = res.data;
    if (remote.status !== 200) {
      // this.$message.error(remote.message);
      this.isAuthorize = '1';
      this.isLoading = false;
      return;
    }
    this.wxAppInfo = remote.data;
    this.isAuthorize = '2';

    this.isLoading = false;
  }

  async postQuery() {
    const sendData: any = {};
    sendData.auth_code = this.authCode;
    const res: AxiosResponse = await this.$axios.post(this.api, sendData);
    const remote = res.data;
    if (remote.status !== 200 && remote.status !== 500) {
      this.$message.error(remote.message);
      this.isAuthorize = '3';
      return;
    }
    if (remote.status === 500) {
      // 该账户已绑定小程序
      this.$message.error(remote.message);
    }
    // 授权成功清空authCode，并且跳转到authorize页面
    this.authCode = '';
    this.$router.push('/setting/authorize');
    await this.query();
  }

  async created() {
    this.authCode = this.$route.query.auth_code || '';
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
    if (this.authCode) {
      await this.postQuery();
    } else {
      await this.query();
    }
  }
}
